














import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import AppLoadingComponent from '@/components/AppLoadingComponent.vue';
import AppBarComponent from '@/components/AppBarComponent.vue';
import Axios from 'axios';

@Component({
	components: {
		AppLoadingComponent,
		AppBarComponent,
	},
})
export default class AppComponent extends Vue {
	public get isLogged() {
		return this.$store.getters['oidc/oidcIsAuthenticated'];
	}
	@Watch('isLogged')
	private onLoggedChanged(val, oldVal) {
		if (val === true) {
			if (!(this.$store.getters['user/getIsAdmin'] || this.$store.getters['user/isInRole']('roam_allowed'))) {
				const isDev = process.env.NODE_ENV === 'development';
				const identityBaseUrl = isDev ? 'https://localhost:5001' : 'https://auth.scmks.ru';
				location.href = identityBaseUrl;
			}
			this.$store.dispatch('russia/updateRegionId', -1);
			Axios.get('/api/russiaresort/day');
		}
	}
}
